button{display:flex}mat-icon{margin:auto;width:18px;height:18px;font-size:18px;color:#dc324f}
/*# sourceMappingURL=shape-feedback-indicator.component.css.map */
